module.exports = __webpack_public_path__ + "img/02Kuka.624862ef.jpg";